// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"326822bd","48":"5274d78c","284":"11cd332a","633":"a225a2d8","971":"534094b9"}[chunkId] + ".css";
};